(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('CentroDocenteDialogController', CentroDocenteDialogController);

    CentroDocenteDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CentroDocente'];

    function CentroDocenteDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CentroDocente) {
        var vm = this;

        vm.centroDocente = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.centroDocente.id !== null) {
                CentroDocente.update(vm.centroDocente, onSaveSuccess, onSaveError);
            } else {
                CentroDocente.save(vm.centroDocente, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:centroDocenteUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
